import * as React from 'react'

import { Box, Icon, Text, dimensions } from '@factorialco/deprecated-design-system'
import clouds from 'assets/images/import-clouds.svg'

import { observer } from 'mobx-react'

interface Props {
  filename?: string
}

const DocumentText = ({ filename, children }: React.PropsWithChildren<Props>) => {
  return filename ? (
    <Box alignItems="center" gap="s12">
      <Icon.Large icon="document-edit" />
      <Text.Normal>{filename}</Text.Normal>
    </Box>
  ) : (
    <Box alignItems="center">
      <Box paddingBottom="s6">
        <img height={dimensions.s64} src={clouds} />
      </Box>
      <Text.Normal>{children}</Text.Normal>
    </Box>
  )
}

export default observer(DocumentText)
